import i18n from "../i18n";

const SUPPORTED_LANGS = new Set(["en", "fr", "es"]);

/** Current UI language for recommendation and PDF report requests. */
export function getAppLang() {
  const lng = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  return SUPPORTED_LANGS.has(lng) ? lng : "en";
}
